<template>
    <div>
        <!-- Bookmark Popup  -->
        <first-run :which="whichPop" :onClose="onCloseHelp" :onNext="onNextPop"
        :pEngine.sync="productEngine" :saveSearchUrl="true" :firstRunSettings="branding.FirstRunSettings"/>
        <!-- First Run Popup -->
        <!----search module----->
        <div class="searchModule">
            <div class="sLogo"><img :src="branding.Logo"></div>
            <div class="searchContainer">
                <div class="searchButtonsContainer">
                    <button class="searchButton" id="rvsButton" @click="onClickrvsButton()" v-bind:style="{ 'border-bottom-width': rvsButtonWidthCom }" value='phone'>Reverse Phone Search</button>
                    <button class="searchButton" id="wsButton" @click="onClickwsButton()" v-bind:style="{ 'border-bottom-width': webButtonWidthCom }" value='web'>Web Search</button>
                </div>
                <div class="search web">
                    <div class="searchCombo">
                        <div id=searchbar @keydown.enter="toProductSearch()">
                            <the-mask id="productSearchBar" :mask="['(###) ###-####']"  v-if="searchType=='phone'" ref="queryInput" v-model='origQuery' v-on:@return="toProductSearch()" v-on:@keydown.enter="toProductSearch()" :placeholder="branding.AutocompletePlaceholder"/>
                        </div>
                        <div id=searchbar @keydown.enter="startWebSearch()">
                            <input id="webSearchBar" ref="queryInput" v-if="searchType=='web'" v-model='origQuery' v-on:@return="startWebSearch()" v-on:@keydown.enter="startWebSearch()" :placeholder="'Search The Web'"/>
                        </div>
                    </div>
                    <div class="s-icon"><i class="fa fa-search"></i></div>
                    <div class="error" v-if="queryErrorEmpty">This field is required, please enter</div>
                    <div class="error" v-if="queryErrorInvalid">Must be a 10 digit phone number</div>
                </div>
            </div>
            <div class="sBtnContainer">
                <button class="btn-search productSearch" v-if="searchType=='phone'" @click="toProductSearch()">{{branding.SearchLabel}}</button>
                <button class="btn-search webSearch" id="websrch-btn" v-if="searchType=='web'" @click="startWebSearch()">Web Search</button>
            </div>
        </div>
        <!----end oksearch module----->
        <!--footer-->
        <footer>
            <div class="serp-footer">
                <div class="logoFooter"><img :src="branding.Logo"><span><i class="fa fa-copyright" aria-hidden="true"></i> <span id="brandDetails"> {{branding.Trademark}}</span> </span></div>
                <ul>
                    <li><a :href="`https://${branding.RootDomain}/terms-of-service/`">Terms of Service </a></li>
                    <li><a :href="`https://${branding.RootDomain}/privacy-policy/`">Privacy</a></li>
                    <li><a :href="`https://${branding.RootDomain}/contact-us/`">Contact Us</a></li>
                </ul>
            </div>
        </footer>
        <!--end of footer-->
    </div>
</template>

<script>
    "use strict"
    import bp  from "babel-polyfill"
    import queryString  from 'query-string'
    import 'whatwg-fetch'
    import Humanize from 'humanize-plus'
    import {getGuid, getSetting, setSetting} from "../storage"
    import {WEB_SEARCH_URL, MAP_SEARCH_API, openUrl}  from '../urls'
    import FirstRun from '../components/FirstRun.vue'
    import {getBranding, PRODUCT_SEARCH_PROVIDERS, DEFAULT_PRODUCT_SEARCH_PROVIDER}  from "../branding"
    import {TheMask} from 'vue-the-mask'
    import {documentReady} from '../common'

    function validatePop(name){
        switch(name){
            case "intro":
            case "i":
                return "intro"
            case "t":
            case "tutorial":
                return "tutorial"
            case "it":
                return "intro-tutorial"
        }

        return false;
    }

    export default {
        name: 'serp',
        components:{
            'first-run':FirstRun,
            'the-mask': TheMask
        },
        data(){
            let qs  = queryString.parse(window.location.search);

            return {
                origQuery: '',
                searchType: 'phone',
                queryErrorEmpty: false,
                queryErrorInvalid: false,
                recentSearches: [],
                guid: qs.guid,
                whichPop: validatePop(qs.pop) || false ,
                branding: getBranding(),
                productEngine: qs.engine,
                rvsButtonWidth: '3px',
                webButtonWidth: '0px',
                firstRunQuery: qs.q || null,
            }
        },
        computed: {
            query() {
                if (this.origQuery.length == 10) {
                    return this.origQuery.slice(0,3) + '-' + this.origQuery.slice(3,6) + '-' + this.origQuery.slice(6,10)
                } else {
                    return this.origQuery
                }
                return ''
            },
             rvsButtonWidthCom() {
                return this.rvsButtonWidth
            },
            webButtonWidthCom() {
                return this.webButtonWidth
            }
        },
        mounted(){
            documentReady.then(async () => {
                this.recentSearches = JSON.parse(getSetting("recentSearches")) || [];
                try {
                    this.guid = await getGuid();

                }
                catch (e) {
                    // Extension not available.
                }
                this.$refs.queryInput.focus();
                
            })
            this.onClickrvsButton()
            
        },
        methods: {
            onClickrvsButton(){

                this.rvsButtonWidth = '3px'
                this.webButtonWidth = '0px'
                this.searchType='phone'
                this.queryErrorEmpty = false;
                this.queryErrorInvalid = false;
                
            },
            onClickwsButton(){
    
                this.rvsButtonWidth = '0px'
                this.webButtonWidth = '3px'
                this.searchType='web'
                this.queryErrorEmpty = false;
                this.queryErrorInvalid = false;
            },
            startWebSearch() {
                let searchParams= {
                    k:this.query,
                    guid:this.guid
                }
                openUrl(`${WEB_SEARCH_URL}?${queryString.stringify(searchParams)}`, false);
            },
            validateMapSearch(withFocus) {
                let {query} = this;
                let errsEmpty = false;
                let errsInvalid = false;
                if(this.searchType == 'phone') {
                    if(query == ""){
                        errsInvalid = false
                        errsEmpty =  errsEmpty  || {}
                        errsEmpty.query = "This field is required, Please enter"
                    } else if (query.length != 12) {
                        errsEmpty = false;
                        errsInvalid = errsInvalid || {}
                        errsInvalid.query = "Must be a 10 digit phone number"

                    }
                }
                
                this.queryErrorEmpty=errsEmpty;
                this.queryErrorInvalid = errsInvalid
                if(withFocus){
                    if(errsEmpty.query || errsInvalid.query)  this.$refs.queryInput.focus();
                }
                return !errsEmpty && !errsInvalid;
            },
            async toProductSearch() {
                if(!this.validateMapSearch(true)) return;
                if (this.recentSearches.unshift(this.query) > 5) {
                    this.recentSearches.pop();
                }
                setSetting("recentSearches", JSON.stringify(this.recentSearches));
                await this.doSearch(this.query);
            },
            async doSearch(term) {
                await openUrl(PRODUCT_SEARCH_PROVIDERS[this.productEngine || DEFAULT_PRODUCT_SEARCH_PROVIDER].url.replace("{{QUERY}}", term), false);
            },
            onNextPop(tag) {
                this.whichPop=validatePop(tag) || false;
            },
            onCloseHelp() {
                if ( this.firstRunQuery != null) {
                    //go immediately into search
                        this.doSearch(this.firstRunQuery)

                } 
                switch(this.whichPop){
                    case "intro-tutorial":
                        this.whichPop = validatePop("i");
                }
                    
                this.whichPop=false
            },
        }
    }
</script>

<style>
    @import './css/search.css';
</style>



// WEBPACK FOOTER //
// src/search/Search.vue